module.exports = __webpack_public_path__ + "img/tnt-logo@2x.d6f70314.png";